<template>
  <div class="MediaController" :class="{'mcp-permanentPanel':enablePermanentPanoramaVideoControls}">
    <div class="mcp-container">
      
      <!-- Play/Pause Button -->
      <md-button class="md-icon-button mcp-playpause" @click="togglePlayingState">
        <PauseIcon v-if="playingState"/>
        <PlayIcon v-else/>
      </md-button>

      <!-- Progress Slider -->
      <span class="mcp-slider-container mcp-progress-slider-container">
        <input class="mcp-slider mcp-progress-slider" type="range" :value="currentTime/duration*100" @input="changeSlider($event)" :style="progressSliderBackground"/>
      </span>
      
      <!-- Progress Display -->
      <span class="mcp-progress">
        <span>{{format(currentTime)}} / </span>
        <span class="mcp-progress-durration">{{format(duration)}}</span>
      </span>

      <md-button v-if="skipable" class="md-icon-button mcp-playpause" @click="skip()">
        <SkipForwardIcon  />
      </md-button>

      <md-button v-if="skipable" class="md-icon-button mcp-playpause" @click="toggleSubtitles()">
        <SubtitlesIcon v-if="withSubtitles" />
        <SubtitlesOutlineIcon v-else/>
      </md-button>

      
      <!-- Volume -->
      <span class="mcp-volume">
        <md-button class="md-icon-button mcp-volume-button" @click="toggleVolume()">
          <VolumeHigh v-if="volume > .66"/>
          <VolumeMedium v-else-if="volume > .33"/>
          <VolumeLow v-else-if="volume > 0"/>
          <VolumeMuteIcon v-else/>
        </md-button>
        <span class="mcp-slider-container mcp-volume-slider-container">
          <input class="mcp-slider mcp-volume-slider" type="range" :value="volume*100" @input="changeVolume($event)" :style="volumeSliderBackground"/>
        </span>
      </span>

    </div>
  </div>
</template>

<style scoped>
  .MediaController{
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
  }
  .mcp-container{
    padding: 5px;
    background: rgba(45, 45, 45, 0.2);
    box-shadow: 0px 0px 6px rgba(61, 61, 61, 0.514);
    border-radius: 5px;
    white-space: nowrap; 
    display: flex;
    align-items: center;

    transition: all 0.1s ease-in-out;
  }
  .mcp-container:hover{
    background: rgba(45, 45, 45, 0.8);
  }
  .mcp-permanentPanel{
    bottom: 90px;
  }
  .mcp-progress{
    display: inline;
    color: white;
    font-size: 16px;
    margin-right: 10px;
  }
  .mcp-progress-durration{
    color: rgb(202, 202, 202);
  }
  .mcp-playpause{
    background: transparent;
  }
  .mcp-volume{
    width: 42px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    transition: .1s width;
    display: flex;
    align-items: center;
    line-height: 0;
  }
  .mcp-volume:hover{
    width: 150px;
  }
  .mcp-volume-slider{
    width: 100px;
  }
  .mcp-volume-button{
    background: transparent;
  }
  .mcp-progress-slider{
    width: 400px;
  }
  .mcp-progress-slider-container{
    margin-left: 2px;
    margin-right: 10px;
  }

  /* Slider CSS */
  .mcp-slider {
    -webkit-appearance: none;
    height: 8px;
    border-radius: 10px;
    display: inline;
    opacity: 0.7;
    transition: opacity .2s;
    background: white;
    cursor: pointer;
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.205));
  }
  .mcp-volume-slider{
    height: 4px;
  }
  .mcp-slider:focus {
    outline: none;
  }
  .mcp-slider:hover {
    opacity: 1;
  }
  .mcp-slider::-webkit-slider-thumb {
    transform: translateX(-1px);
    -webkit-appearance: none;
    width: 0px;
    height: 0px;
    background: var(--primaryColor);
    border-radius: 50%;
    cursor: pointer;
    transition: width .2s, height .2s;
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.178));
  }
  .mcp-slider::-moz-range-thumb { 
    transform: translateX(-1px);
    width: 0px;
    height: 0px;
    background: var(--primaryColor);
    border-radius: 50%;
    cursor: pointer;
    transition: width .2s, height .2s;
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.178));
    border: none;
  }
  .mcp-progress-slider-container:hover input[type="range"]::-webkit-slider-thumb {
    width: 19px;
    height: 19px;
  }
  .mcp-progress-slider-container:hover input[type="range"]::-moz-range-thumb {
    width: 19px;
    height: 19px;
  }
  .mcp-volume-slider-container:hover input[type="range"]::-webkit-slider-thumb {
    width: 16px;
    height: 16px;
  }
  .mcp-volume-slider-container:hover input[type="range"]::-moz-range-thumb {
    width: 16px;
    height: 16px;
  }

  .md-button{
    margin: 0;
    padding: 0;
    z-index: 0;
  }

  /*MOBILE*/
  @media (max-device-width: 900px){
    .mcp-permanentPanel{
      bottom: 90px;
    }
    .mcp-progress-slider-container{
      width: 90%;
    }
    .mcp-progress-slider{
      width: 100%;
    }
    /*
    .mcp-volume{
      display: none;
    }
    .mcp-progress{
      display: none;
    }
    */
    .mcp-container{
      width: 95%
    }
  }
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import VolumeMuteIcon from "vue-material-design-icons/VolumeMute.vue";
import VolumeIcon from "vue-material-design-icons/VolumeMedium.vue";
import VolumeLow from "vue-material-design-icons/VolumeLow.vue";
import VolumeMedium from "vue-material-design-icons/VolumeMedium.vue";
import VolumeHigh from "vue-material-design-icons/VolumeHigh.vue";

import ResetIcon from "vue-material-design-icons/Undo.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";
import PauseIcon from "vue-material-design-icons/Pause.vue";
import SubtitlesIcon from "vue-material-design-icons/Subtitles.vue";
import SubtitlesOutlineIcon from "vue-material-design-icons/SubtitlesOutline.vue";
import SkipForwardIcon from "vue-material-design-icons/SkipForward.vue";

import { Prefab } from "@/store/flux360/PrefabDataTypes";

export default {
  components: { VolumeMuteIcon, VolumeIcon, ResetIcon, PlayIcon, PauseIcon,VolumeHigh,VolumeMedium,VolumeLow, SkipForwardIcon, SubtitlesIcon, SubtitlesOutlineIcon},
  data: () => ({

    // Safe volume user sets to overwrite volume of other videos when user changed the volume
    //  ->Every video should have the volume the user sets when changing situation
    // Video volume is based on the volume of the video and thats 1 per default, therefore the user can change the audio for each video individually but thats probably not wanted
    userVolume: 1,

    // When User mutes Video through the mute button we safe the old volume
    // When User unmutes Video the volume gets set to the oldVolume
    oldUserVolume: 1,

    // Safe duration of last panorama video because the duration switches to 0 and NaN when changing panorama videos
    // To prevent the number flickering in the UI we use the old duration whenever the current duration is 0
    oldDuration: 0,
    
    firstTime: true,
  }), 
 
  computed: {
    ...mapGetters(["currentPrefabs", "allPrefabs", "currentSituation","enablePermanentPanoramaVideoControls","enablePanoramaVideoAutoplay", "currentPrefabs", "withSubtitles"]),

    // checks if panorama video is currently playing 
    // returns true if panorama video is playing
    playingState() {
      var playing = false;  
      if (this.currentSituation) 
        if (this.currentSituation.runtimeState.paused != true && this.currentSituation.runtimeState.paused != undefined) 
          playing = true;    

      return playing;
    },
    skipable(){
      let transitions = this.currentPrefabs.filter((x) =>
        x.isOfType(Prefab.PrefabType.Transition)
      );
      //console.log(transitions)
      let x = false;
      transitions.forEach(element => {
        if(element.automaticJump=="true"){
          x=true;
        }
      });
      return x;
    },
    // returns duration of the panorama video in seconds
    duration() {
      var duration = 0;

      if (this.currentSituation) 
        if (this.currentSituation.getType() === Prefab.PrefabType.SituationVideo)
          duration = this.currentSituation.runtimeState.duration;

      // return switches to NaN when changing Situations and is per default -1. To prevent UI flickering when switching situations return duration of last panorama video
      if(duration < 0)
        duration = this.oldDuration;

      return duration;
    },

    // returns loaded data of video in %
    // used in slider to indicate how much of the video is loaded
    percentageLoaded(){
      var percentageLoaded = 0;

      if (this.currentSituation) 
        if (this.currentSituation.getType() === Prefab.PrefabType.SituationVideo)
          percentageLoaded = this.currentSituation.runtimeState.percentageLoaded;

      return percentageLoaded;
    },

    // returns currentTime of the panorama video in seconds
    currentTime() {
      var currentTime = 0;

      if (this.currentSituation) 
        if (this.currentSituation.getType() === Prefab.PrefabType.SituationVideo)
           currentTime = this.currentSituation.runtimeState.currentTime;
      
      // currenTime switches to NaN when changing Situations. To prevent UI flickering/errors return 0 
      if(isNaN(currentTime))
        currentTime = 0;

      return currentTime;
    },

    // returns volume of the panorama video range [0,1]
    volume() {
      var volume = 0;

      if (this.currentSituation) 
        if (this.currentSituation.getType() === Prefab.PrefabType.SituationVideo)
          volume = this.currentSituation.runtimeState.volume;
      
      // volume switches to undefined when changing Situations. To prevent UI flickering return volume the user set 
      if(volume == undefined)
        volume = this.userVolume;
      return volume;
    },

    progressSliderBackground(){
      let progress = Math.floor(this.duration !=0 ? (this.currentTime/this.duration*100+.5) : 0);
      let loaded = Math.floor(this.percentageLoaded);
      return 'background: linear-gradient(to right, var(--primaryColor) 0%, var(--primaryColor) ' + progress+ '%, white ' + progress+ '%, white ' + loaded + '%, grey ' + loaded + '%);';
    },

    volumeSliderBackground(){
      let volume = this.volume*100+.5;
      return 'background: linear-gradient(to right, var(--primaryColor) 0%, var(--primaryColor) ' + volume + '%, #fff ' + volume + '%, white 100%);';
    }
  },
  methods: {
    ...mapMutations(["handleGotoSituationTransition", "setWithSubtitles"]),
    // Takes time in seconds and returns String as formate time to Minutes:Seconds e.g. 1:55 = 1 Minute 55 Seconds , 2:01 = 2 Minuts 1 second
    format(time) {
      var mins = Math.floor(time / 60);
      var secs = Math.floor(time - mins * 60);
      return mins + ":" + (secs < 10 ? "0" : "") + secs;
    },

    // changes currentTime of panorama video
    // runtimeState workflow to change panorama video data:
    // 1. sends request to runtimeState
    // 2. runtimeState reuqest gets resolved in renderLoop inside PanoramaScene (update of runtimeState)
    changeSlider(e) {
      let time = e.target.value / 100 * this.duration;

      if(this.currentSituation.getType() === Prefab.PrefabType.SituationVideo)
        this.currentSituation.runtimeState.requestJumpToTimePosition("this.localUser", time);
    },

    // changes volume of panorama video
    changeVolume(e) {
      let volume = e.target ? e.target.value/100 : e;

      this.userVolume = volume;

      if(this.currentSituation.getType() === Prefab.PrefabType.SituationVideo)
        this.currentSituation.runtimeState.requestChangeVolume("this.localUser", volume);
    },

    // Mutes/Unmutes audio of panorama video
    // if volume > 0 mute audio (volume == 0 will trigger mute on panorama video)
    // if volume < 0 unmute audio and set it back to the volume before the user muted 
    toggleVolume(){
      this.volume > 0 ? this.changeVolume(0): this.changeVolume(this.oldUserVolume); this.oldUserVolume = this.volume;
    },

    // Toggles playingstate of panorama video
    // if playingState is true (= panorama video is playing) pause panorama video
    // if playingState is false (= panorama video is not playing) play panorama video
    // play/pause functions will affect playingstate
    togglePlayingState() {
      this.playingState ? this.pause(): this.play();
    },

    toggleSubtitles(){
      this.setWithSubtitles(!this.withSubtitles)
    },
    skip(){
      
      let transitions = this.currentPrefabs.filter((x) =>
        x.isOfType(Prefab.PrefabType.Transition)
      );
      let targetID = null;
      transitions.forEach(element => {
        if(element.automaticJump=="true"){
          targetID = element.targetID;
        }
      });
      if(targetID!=null){
        this.handleGotoSituationTransition({situationID: targetID});     
      }
    },
    // Pauses panorama video
    pause() {
      if (this.currentSituation.runtimeState != null)
        this.currentSituation.runtimeState.requestPause("this.localUser");
    },

    // Plays panorama video
    play() {
      if (this.currentSituation.runtimeState != null)
        this.currentSituation.runtimeState.requestPlay("this.localUser");
    },

  },
  watch: {
    // changeVolume of situation video to current volume whenever the user changes the situatio
    // therefore the user wont get surprised by increased volume, when he changed the volume in the current panorama
    currentSituation: function(){
     if( this.firstTime == true) 
        this.currentSituation.runtimeState.requestChangeVolume("this.localUser", 1);

      this.firstTime ? this.firstTime = false: this.changeVolume(this.userVolume);
      this.oldDuration = this.duration;
    }
  },
};
</script>